import itLocale from 'element-ui/lib/locale/lang/it'
import home from './it/home'

const it = {
    language: 'Русский',
    message: {
        'home': {
            ...home,
            enterEmail: 'Inserisci l\'email',
            save: 'Salva',
            saveSuccess: 'Salvato con successo',
            pointHistory: 'Cronologia punti',
            type: 'Tipo',
            remark: 'Nota',
            pendingComment: 'Da recensire',
            commented: 'Recensito',
            selectDate: 'Seleziona data',
            loginSuccess: 'Accesso riuscito',
            loginFail: 'Accesso non riuscito',
            close: 'Chiudi',
            required: 'Obbligatorio',
            nickname: 'Nickname',
            enterNickname: 'Inserisci il nickname',
            gender: 'Sesso',
            male: 'Uomo',
            female: 'Donna',
            secret: 'Riservato',
            birthday: 'Compleanno',
            checkoutLoadFailed: 'Caricamento delle informazioni di pagamento non riuscito. Riprova più tardi.',
            checkoutErrorTitle: 'Avviso',
            goAddAddress: 'Aggiungi indirizzo di spedizione',
            shop_order_selectOrAddAddress: 'Aggiungi prima un indirizzo di spedizione e impostalo come predefinito prima di procedere all\'ordine.',
            shop_order_cartEmpty: 'Il carrello è vuoto, impossibile procedere all\'ordine.',
            shop_order_cartHasNotActive: 'Sono presenti articoli non in vendita o non validi, impossibile procedere all\'ordine.',
            shop_order_cartHasNotMarketable: 'Sono presenti articoli rimossi, impossibile procedere all\'ordine.',
            shop_order_cartHasLowStock: 'Scorte insufficienti, impossibile procedere all\'ordine.',
            shop_order_cartHasExpiredGoods: 'Alcuni articoli del negozio sono scaduti, impossibile procedere all\'ordine.',
            shop_order_typeIsNull: 'Tipo di ordine non riconosciuto, controlla il tipo di articolo.',
            shop_order_goodsNotFound: 'Le informazioni sul prodotto non esistono o sono state eliminate.',
            shop_order_giftNotForSale: 'Gli articoli omaggio non possono essere acquistati direttamente.',
            common_message_badRequest: 'Richiesta non valida, controlla il prodotto e i parametri.',
        },
    },
    '手机号码最小长度为8位': 'La lunghezza minima del numero di cellulare è di 8 cifre',
    '邮箱账号名称最小长度为6位': "La lunghezza minima del nome dell'account e-mail è di 6 caratteri",
    '邮箱只能包含英文，数字等字符': "La casella di posta può contenere solo caratteri come inglese e numeri",
    '请选择正确的收货地址': "Seleziona l'indirizzo di spedizione corretto",
    Dict_language_status_0: 'Disabilitato',
    Dict_language_status_1: 'Abilitato',
    Dict_member_label_type_1: 'Etichetta condizionale',
    Dict_member_label_type_2: 'Etichetta manuale',
    Dict_member_level_type_0: 'Livello di consumo (LV)',
    Dict_member_level_type_1: 'Membro a pagamento (VIP)',
    Dict_member_growth_action_type_1: 'Effettuare un ordine',
    Dict_member_growth_action_type_2: 'Accesso giornaliero',
    Dict_member_growth_action_type_3: 'Pubblicare una recensione',
    Dict_member_growth_action_type_4: 'Completare il profilo',
    Dict_paid_member_payment_type_0: 'Pagamento con saldo',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Valido',
    Dict_paid_member_record_status_1: 'Scaduto',
    Dict_paid_member_record_status_2: 'Rimborsato',
    Dict_point_lottery_prize_type_0: 'Punti',
    Dict_point_lottery_prize_type_1: 'Coupon',
    Dict_point_lottery_prize_type_2: 'Premio fisico',
    Dict_point_lottery_prize_type_3: 'Grazie per la partecipazione',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'Email',
    Dict_notification_channel_type_2: 'Messaggio interno',
    Dict_notification_channel_type_3: 'Notifica push',
    Dict_announcement_status_0: 'Bozza',
    Dict_announcement_status_1: 'Pubblicato',
    Dict_announcement_status_2: 'Ritirato',
    Dict_live_permission_status_0: 'Non richiesto',
    Dict_live_permission_status_1: 'In revisione',
    Dict_live_permission_status_2: 'Attivato',
    Dict_live_permission_status_3: 'Rifiutato',
    Dict_live_room_status_0: 'Non iniziato',
    Dict_live_room_status_1: 'In diretta',
    Dict_live_room_status_2: 'Terminato',
    Dict_live_room_status_3: 'Interruzione anomala',
    Dict_live_room_type_0: 'Diretta piattaforma',
    Dict_live_room_type_1: 'Diretta commerciante',
    Dict_store_type_0: 'Negozio individuale',
    Dict_store_type_1: 'Negozio aziendale',
    Dict_store_sign_status_0: 'In attesa di firma',
    Dict_store_sign_status_1: 'Firmato',
    Dict_store_sign_status_2: 'Risolto',
    Dict_store_business_change_status_0: 'In attesa di revisione',
    Dict_store_business_change_status_1: 'Approvato',
    Dict_store_business_change_status_2: 'Rifiutato',
    Dict_decoration_page_type_0: 'Home page',
    Dict_decoration_page_type_1: 'Pagina categoria',
    Dict_decoration_page_type_2: 'Pagina campagna',
    Dict_decoration_page_type_3: 'Pagina personalizzata',
    Dict_decoration_status_0: 'Bozza',
    Dict_decoration_status_1: 'Pubblicato',
    Dict_decoration_popup_trigger_page_0: 'Home della piattaforma',
    Dict_decoration_popup_trigger_page_1: 'Area membri',
    Dict_decoration_popup_trigger_page_2: 'Pagamento riuscito',
    Dict_decoration_popup_target_user_0: 'Tutti gli utenti',
    Dict_decoration_popup_target_user_1: 'Membri gratuiti',
    Dict_decoration_popup_target_user_2: 'Membri a pagamento',
    Dict_decoration_popup_frequency_0: 'Una volta in modo permanente',
    Dict_decoration_popup_frequency_1: 'Ad ogni visita',
    Dict_decoration_popup_frequency_2: 'Frequenza personalizzata',
    Dict_track_event_type_page_view: 'Visualizzazione pagina',
    Dict_track_event_type_click: 'Clic',
    Dict_track_event_type_add_to_cart: 'Aggiungi al carrello',
    Dict_track_event_type_search: 'Ricerca',
    Dict_track_event_type_purchase: 'Acquisto',
    Dict_track_event_type_live_watch: 'Guarda la diretta',
    Dict_reconcile_period_type_0: 'Giornaliero',
    Dict_reconcile_period_type_1: 'Settimanale',
    Dict_reconcile_period_type_2: 'Mensile',
    Dict_store_settlement_status_0: 'In attesa di liquidazione',
    Dict_store_settlement_status_1: 'Liquidato',
    Dict_distributor_status_0: 'In attesa di revisione',
    Dict_distributor_status_1: 'Revisionato',
    Dict_distributor_status_2: 'Rifiutato',
    Dict_distribution_commission_type_0: 'Commissione diretta',
    Dict_distribution_commission_type_1: 'Commissione indiretta',
    Dict_configuration_status_0: 'Disabilitato',
    Dict_configuration_status_1: 'Abilitato',
    ...itLocale
}
export default it
